var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('AppNavigation'),_c('SnackBar'),_c('update-notifier'),_c('v-content',{attrs:{"transition":"slide-x-transition"}},[_c('transition',[_c('keep-alive',[_c('router-view',{key:_vm.$route.path})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }